import {EXTENSION_ID} from 'src/chat-extension/constants';
import {UPDATE_FARO_URL} from 'src/chat-extension/messages';
import logger from 'src/utils/logger';


export const sendMessageToExtension = (
  type: string,
  payload: unknown,
): void => {
  try {
    const chrome = window.chrome;
    if (!chrome || !chrome.runtime) {
      return;
    }
    chrome.runtime.sendMessage(EXTENSION_ID, {type, payload});
  } catch (error) {
    logger.error('Error sending message to extension', error);
  }
};

/** Syncs SSR `env.faroUrl` from the extension iframe to extension storage. */
export const syncFaroUrlToExtension = (faroUrl: string): void => {
  if (!faroUrl) {
    return;
  }
  sendMessageToExtension(UPDATE_FARO_URL, faroUrl);
};
